module.exports = __webpack_public_path__ + "img/Clients_Banner.bcbae974.svg";